import { Alert } from '@verbit-ai/verbit-ui-library'
import { useMicSilenceAlert } from '@verbit-ai/verbit-connect-web/hooks'

import * as S from './styles'

const WARNING_MESSAGE = "Your microphone seems silent. If this is not deliberate, make sure it's connected and not muted."
const SILENCE_THRESHOLD_MS = 3 * 60 * 1_000

export const MicSilenceWarning = () => {
    const { isWarningVisible } = useMicSilenceAlert({
        silenceThresholdMs: SILENCE_THRESHOLD_MS,
    })

    if (!isWarningVisible) {
        return null
    }

    return (
        <S.CenteredAlertContainer>
            <Alert text={WARNING_MESSAGE} status="error" />
        </S.CenteredAlertContainer>
    )
}
